<template>
  <el-radio
    v-bind="$attrs"
    class="rt-radio"
    v-on="$listeners"
  >
    <slot />
  </el-radio>
</template>

<script>
export default {
  name: 'RtRadio'
};
</script>



// WEBPACK FOOTER //
// rtRadio.vue?66782b0a